<template>
  <div
    class="modal-navigation"
    :class="{
      'col-1': itemsCount === 1,
      'col-2': hasEqualTwoColumns,
      'col-3': itemsCount === 3,
      highlighted: highlighted,
      bordered: bordered
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ModalWindowNavigation',
  props: {
    itemsCount: {
      type: Number,
      default: 2
    },
    highlighted: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    hasEqualTwoColumns: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.modal-navigation {
  display: grid;
  grid-template-columns: 2fr 1fr;
  width: 100%;
  gap: var(--space-12);

  &.bordered {
    margin-top: var(--space-24);
    padding-top: var(--space-24);
    border-top: #eeeeee solid 1px;
  }

  &.col-1 {
    grid-template-columns: 1fr;
  }

  &.col-2 {
    grid-template-columns: repeat(2, 1fr);
  }

  &.col-3 {
    grid-template-columns: repeat(3, 1fr);
  }

  &.highlighted {
    box-shadow: 0 -3px 8px 0 #0000001f;
  }
}
</style>
